import * as React from "react";
import { BreadcrumbGroup, BreadcrumbGroupProps } from "@amzn/awsui-components-react";
import { useInstanceDataContext } from "../../contexts/InstanceDataContext";
import { extractInstanceFromParams } from "../../setup/useRoutedParamsWithContext";
import { useParams } from "react-router-dom";

/**
 * Wrapper component that automatically adds home navigation breadcrumbs.
 * Breadcrumb structure: PathFinder Home -> Instance Name -> {Page breadcrumbs}
 */
export const HomeBreadcrumbWrapper: React.FC<{ items: BreadcrumbGroupProps.Item[] }> = ({ items }) => {
    const { instanceCache } = useInstanceDataContext();
    const params = useParams();

    const instanceId = extractInstanceFromParams(params);
    const instance = instanceId ? instanceCache[instanceId] : null;
    const instanceDisplayName = instance?.name || "Instance";

    const isInstanceHomePage = window.location.hash.includes(`/instance/${instanceId}/home`);

    const homeBreadcrumbs: BreadcrumbGroupProps.Item[] = [
        {
            text: "PathFinder Home",
            href: "#/?home=true"
        },
        {
            text: instanceDisplayName,
            href: isInstanceHomePage ? "#" : (instanceId ? `#/instance/${instanceId}/home` : "#/")
        }
    ];

    const enhancedItems = [...homeBreadcrumbs, ...items];
    return (
        <div className={isInstanceHomePage && "instance-home-breadcrumb"}>
            <BreadcrumbGroup items={enhancedItems} />
        </div>
    );
};
